import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  InAppBrowser,
  InAppBrowserOptions,
} from "@ionic-native/in-app-browser/ngx";
import {
  AlertController,
  LoadingController,
  ModalController,
} from "@ionic/angular";
import { STORAGE } from "src/app/constant/storages";
import { ApiserviceService } from "src/app/httpservice/apiservice.service";
import { AppService } from "src/app/services/app.service";
import { _getStorage } from "src/app/utils/local-storage";
import { ResendTaxinvoiceComponent } from "../resend-taxinvoice/resend-taxinvoice.component";

@Component({
  selector: "app-resend-select-taxinvoice",
  templateUrl: "./resend-select-taxinvoice.component.html",
  styleUrls: ["./resend-select-taxinvoice.component.scss"],
})
export class ResendSelectTaxinvoiceComponent implements OnInit {
  allComplete: boolean = false;
  task: any = {
    name: "Indeterminate",
    completed: false,
    subtasks: [],
  };
  loading = false;
  formResend: any;
  pages: any = [];
  isFirstPage: boolean = true;
  isLastPage: boolean = false;
  countpage = 0;
  formDate: any;
  groupCount: any;

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  options: InAppBrowserOptions = {
    location: "yes", //Or 'no'
    hideurlbar: "yes",
    navigationbuttoncolor: "white",
    toolbarcolor: "red",
    toolbarposition: "top",
    closebuttoncaption: "CLOSE",
    closebuttoncolor: "white",
    hidden: "no", //Or  'yes'
    clearcache: "yes",
    clearsessioncache: "yes",
    zoom: "yes", //Android only ,shows browser zoom controls
    hardwareback: "yes",
    mediaPlaybackRequiresUserAction: "no",
    shouldPauseOnSuspend: "no", //Android only
    disallowoverscroll: "no", //iOS only
    toolbar: "yes", //iOS only
    enableViewportScale: "no", //iOS only
    allowInlineMediaPlayback: "no", //iOS only
    presentationstyle: "pagesheet", //iOS only
    fullscreen: "yes", //Windows only
  };

  lastPage: number = 0;
  currPage: number = 0;

  formData: any;

  constructor(
    public modalController: ModalController,
    public appService: AppService,
    private route: ActivatedRoute,
    private router: Router,
    private apiservice: ApiserviceService,
    private iab: InAppBrowser,
    private alertController: AlertController,
    private loadingController: LoadingController
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);

    this.route.queryParams.subscribe(async (params) => {
      if (Object.keys(params).length !== 0) {
        console.log("params====: ", params.formResend);
        this.formData = params.formResend;
        const { formResend } = params;
        this.formResend = JSON.parse(formResend);
        await this.callApi(JSON.parse(formResend));
        console.log("reportId", this.formResend);
        this.formDate = this.formResend;
      }
    });
  }

  ngOnInit() {
    this.loading = true;
  }

  async callApi(formResend) {
    this.loading = true;
    console.log("formResend", formResend);

    let startDatetmp = new Date(formResend.resendDateStart);
    let endDatetmp = new Date(formResend.resendDateTo);

    let tmpStartDate =
      startDatetmp.getFullYear() +
      "-" +
      (startDatetmp.getMonth() + 1) +
      "-" +
      startDatetmp.getDate() +
      " 00:00:00";
    let tmpEndDate =
      endDatetmp.getFullYear() +
      "-" +
      (endDatetmp.getMonth() + 1) +
      "-" +
      endDatetmp.getDate() +
      " 23:59:59";

    console.log("set temp req date : >>> ", tmpStartDate, "][", tmpEndDate);
    formResend.resendDateStart = tmpStartDate;
    formResend.resendDateTo = tmpEndDate;

    this.allComplete = false;
    this.task = {
      completed: false,
      subtasks: [],
    };
    const url = `${this.apiservice.apiUrl}${this.apiservice.inquirySearchList}`;
    const req = {
      page: "1",
      userRole: this.userRole,
      userBu: this.userBu,
      userLoc: this.userLoc,
      userSource: this.userSource,
      tel: [formResend.phoneNumber],
      company_name: formResend.companyName,
      buyer_tax_id: this.formResend.idCardNumber,
      abb_no: this.formResend.taxId,
      userid: this.userID,
      type: "",
      startdate: formResend.resendDateStart,
      enddate: formResend.resendDateTo,
      page_name: "resendprint",
    };
    console.log("====== req Resend =======", req);
    try {
      const res = await this.apiservice._post(url, req);
      this.loading = false;
      console.log("====== res Resend =======", req);

      if (res.result === "S") {
        res.data.invoice_list.forEach((t) => {
          this.task.subtasks = [
            ...this.task.subtasks,
            { ...t, completed: false },
          ];
        });

        this.groupCount = res.data.count;
        await this.logicPagination(0);
      }
    } catch (error) {
      this.loading = false;
    }
  }

  itemView(data: any) {
    console.log("itemView=====: ", data);
    const navigationExtras = {
      queryParams: {
        tax_invoice_no:
          data.type_invoice != "creditnote"
            ? data.tax_invoice_no
            : data.creditnote_no,
        items: JSON.stringify(data),
        formData: this.formData,
        mtrans_id: data.mtrans_id,
      },
    };
    this.router.navigate(["resend-detail"], navigationExtras);
  }

  async presentModal() {
    let countEmail = [];
    let checkData = [];
    this.task.subtasks.forEach((element) => {
      if (element.completed) {
        checkData.push(element);
        const checkEmail = element.email;
        const index = countEmail.findIndex((e) => e.email === checkEmail);
        if (index === -1) {
          countEmail = [
            ...countEmail,
            {
              email: checkEmail,
              count: 1,
            },
          ];
        } else {
          countEmail[index] = {
            ...countEmail[index],
            count: countEmail[index].count + 1,
          };
        }
      }
    });
    if (countEmail.length) {
      let sendEmail = "";
      if (countEmail.length > 1) {
        const data = Math.max.apply(
          Math,
          countEmail.map((o) => {
            return o.count;
          })
        );
        const email = countEmail.find((e) => e.count === data);
        sendEmail = email.email;
      } else {
        sendEmail = countEmail[0].email;
      }
      // this.presentAlertPrompt(sendEmail);

      console.log("checkData =====>>>>> ", checkData);
      this.appService.setActive(3);
      const modal = await this.modalController.create({
        component: ResendTaxinvoiceComponent,
        cssClass: "my-custom-class",
        componentProps: { sendEmail: sendEmail, data: checkData },
      });
      modal.onDidDismiss().then(async () => {
        this.appService.setActive(2);
        this.allComplete = false;
        this.task.completed = false;
        this.task.subtasks.forEach((i) => {
          i.completed = false;
        });
      });
      await modal.present();
    } else {
      this.presentAlert();
    }
  }

  async presentAlert() {
    const alert = await this.alertController.create({
      header: "Alert",
      message: "กรุณาเลือกใบกำกับภาษี",
      buttons: ["ตกลง"],
    });
    await alert.present();
  }

  async presentAlertPrompt(sendEmail) {
    const alert = await this.alertController.create({
      // mode: 'ios',
      message: "ต้องการ Resend เอกสารอิเล็กทรอนิกส์ ผ่าน E-mail หรือไม่ ?",
      inputs: [
        {
          name: "email",
          id: "email",
          type: "text",
          value: sendEmail,
          placeholder: "Email",
        },
      ],
      buttons: [
        {
          text: "ยกเลิก",
          role: "cancel",
          cssClass: "alertCancel",
          handler: () => {
            console.log("Confirm Cancel");
          },
        },
        {
          text: "ยืนยัน",
          cssClass: "alertOk",
          handler: (e) => {
            console.log("Confirm Ok", e.email);
          },
        },
      ],
    });

    await alert.present();
  }

  updateAllComplete() {
    this.allComplete =
      this.task.subtasks != null &&
      this.task.subtasks.every((t) => t.completed);
  }

  someComplete(): boolean {
    if (this.task.subtasks == null) {
      return false;
    }
    return (
      this.task.subtasks.filter((t) => t.completed).length > 0 &&
      !this.allComplete
    );
  }

  setAll(completed: boolean) {
    this.allComplete = completed;
    if (this.task.subtasks == null) {
      return;
    }
    this.task.subtasks.forEach((t) => (t.completed = completed));
  }

  async getPDF(item) {
    let target = "_self";
    const req_load_pdf = {
      taxno:
        item.type_invoice != "creditnote"
          ? item.tax_invoice_no
          : item.creditnote_no,
      storebu: item.bu,
      storeid: item.loc,
      userBu: this.userBu,
      userLoc: this.userLoc,
      userRole: this.userRole,
      userSource: this.userSource,
      user_id: this.userID,
      mtrans_id: item.mtrans_id,
    };

    this.apiservice
      ._post(this.apiservice.apiUrl + this.apiservice.getNewPDF, req_load_pdf)
      .then(async (res: any) => {
        console.log("============ res get data pdf ===========", res);
        if (res.statusCode === 200) {
          const browser = this.iab.create(res.data, target, this.options);
        } else {
          this.ErrorMsg(res.statusMessage);
        }
      });
  }

  async currentPage(page: any) {
    console.log("[currentPage] page : ", page);
    this.countpage = page - 1;

    this.currPage = parseInt(page);
    await this.getResendData(page, "N");
    await this.logicPagination(page);
  }

  async getResendData(page: any, isNext: string) {
    this.task.subtasks = [];
    let startDatetmp = new Date(this.formResend.resendDateStart);
    let endDatetmp = new Date(this.formResend.resendDateTo);

    let tmpStartDate =
      startDatetmp.getFullYear() +
      "-" +
      (startDatetmp.getMonth() + 1) +
      "-" +
      startDatetmp.getDate() +
      " 00:00:00";
    let tmpEndDate =
      endDatetmp.getFullYear() +
      "-" +
      (endDatetmp.getMonth() + 1) +
      "-" +
      endDatetmp.getDate() +
      " 23:59:59";

    console.log("set temp req date : >>> ", tmpStartDate, "][", tmpEndDate);
    this.formResend.resendDateStart = tmpStartDate;
    this.formResend.resendDateTo = tmpEndDate;

    const loading = await this.apiservice.loading();
    loading.present();

    let req = {
      page: page.toString(),
      userRole: this.userRole,
      userBu: this.userBu,
      userLoc: this.userLoc,
      userSource: this.userSource,
      userid: this.userID,
      tel: this.formResend.phoneNumber,
      company_name: this.formResend.companyName,
      buyer_tax_id: this.formResend.idCardNumber,
      abb_no: this.formResend.taxId,
      type: "",
      startdate: this.formResend.resendDateStart,
      enddate: this.formResend.resendDateTo,
      page_name: "resendprint",
    };
    console.log("req Resend...", req);
    try {
      const res = await this.apiservice._post(
        this.apiservice.apiUrl + this.apiservice.inquirySearchList,
        req
      );
      this.loading = false;
      console.log("res...", res);
      if (res.result === "S") {
        if (isNext == "Y") {
          this.pages.push(page);
        }
        if (this.lastPage <= 1) {
          this.isFirstPage = true;
          this.isLastPage = true;
        } else if (this.currPage === 1) {
          this.isFirstPage = true;
          this.isLastPage = false;
        } else if (this.currPage >= this.lastPage) {
          this.isLastPage = true;
          this.isFirstPage = false;
        } else if (this.lastPage > 1) {
          this.isLastPage = false;
          this.isFirstPage = false;
        } else {
          this.isLastPage = false;
        }

        res.data.invoice_list.forEach((t) => {
          this.task.subtasks = [
            ...this.task.subtasks,
            { ...t, completed: false },
          ];
        });
      }
      loading.dismiss();
    } catch (error) {
      this.loading = false;
      loading.dismiss();
    }
  }
  checkbranch(data: any) {
    // console.log('[-------data branch------]', data);
    if (data.buyer_type === "0") {
      return "-";
    } else if (data.buyer_type === "1") {
      if (data.Mbranch_no === "สำนักงานใหญ่") {
        return "สำนักงานใหญ่";
      } else {
        return data.branch_no;
      }
    } else if (data.buyer_type === "2") {
      return "-";
    } else {
      return "-";
    }
  }
  checkaddr(item) {
    if (item.type_addr === "" || item.type_addr === undefined) {
      return "-";
    } else if (item.type_addr === "1") {
      return item.display_address === "" ? "-" : item.display_address;
    } else {
      return item.display_addressEN === "" ? "-" : item.display_addressEN;
    }
  }
  checkdownload(item) {
    // console.log('check download ....',item);
    if (item.invoice_status === "ใช้งาน") {
      return false;
    } else if (item.invoice_status === "ยกเลิก") {
      return true;
    }
  }
  checkBox(item) {
    console.log("completed.....", item);
    if (item) {
      return true;
    }
  }
  checkstatus(item) {
    // console.log('status....',item);
    if (item.invoice_status === "complete") {
      return "ใช้งาน";
    } else if (item.invoice_status === "cancel") {
      return "ยกเลิก";
    }
  }

  checkabb(data: any) {
    let branch_no = data.split("-");
    // console.log('temp_no', branch_no);
    let numberBranch = branch_no[0] + "-" + branch_no[1].padStart(6, "0");
    return numberBranch;
  }

  listPage: any;

  logicPagination(page) {
    let pageSize: number = 10;
    this.countpage = page - 1;
    let totalPages = Math.ceil(this.groupCount / pageSize);
    if (this.currPage < 1) {
      this.currPage = 1;
    } else if (this.currPage > totalPages) {
      this.currPage = totalPages;
    }

    let startPage: number, endPage: number;
    if (totalPages <= 10) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (this.currPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (this.currPage + 4 >= totalPages) {
        startPage = totalPages - 5;
        endPage = totalPages;
      } else {
        startPage = this.currPage - 5;
        endPage = this.currPage + 4;
      }
    }

    this.listPage = Array.from(Array(endPage + 1 - startPage).keys()).map(
      (i) => startPage + i
    );

    this.lastPage = Math.ceil(this.groupCount / 10);
    if (this.lastPage <= 1) {
      this.isFirstPage = true;
      this.isLastPage = true;
    } else if (this.currPage === 1) {
      this.isFirstPage = true;
      this.isLastPage = false;
    } else if (this.currPage >= this.lastPage) {
      this.isLastPage = true;
      this.isFirstPage = false;
    } else if (this.lastPage > 1) {
      this.isLastPage = false;
      this.isFirstPage = false;
    } else {
      this.isLastPage = false;
    }
  }
  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }
}
